import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, errorText } from '../api';
import { useApp } from '../context';
import { useFormFields } from '../hooks/useFormFields';

export function useBusinessAuth(register, initialRole = 'buyer') {
  const { setUser } = useApp();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const fields = useFormFields({ name: '', company: '', email: '', password: '',
    role: initialRole === 'supplier' ? 'supplier' : 'buyer', tax_id: '', city: '', state_code: '27' });

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    const { email, password } = fields.form;
    try {
      const { data } = await api.post(register ? '/auth/register' : '/auth/login', register ? fields.form : { email, password });
      setUser(data.user);
      navigate('/workspace');
    } catch (requestError) {
      setError(errorText(requestError));
    } finally { setBusy(false); }
  }
  return { ...fields, busy, error, submit };
}